export default function download(allId, byId, column, columnName, filename) {
  const escapeCsv = (val) => {
    if (val === null || val === undefined) return '';
    const str = String(val);
    // Если есть кавычки, точки с запятой или переносы строк — оборачиваем в кавычки
    if (str.includes(';') || str.includes('"') || str.includes('\n') || str.includes('\r')) {
      return `"${str.replace(/"/g, '""')}"`;
    }
    return str;
  };
  const data = allId.map(key => {
    return column.map(value => escapeCsv(byId[key]?.[value])).join(';') + '\n';
  })
  const formattedHeaders = columnName.map(name => escapeCsv(name)).join(';');
  data.unshift('\ufeff' + formattedHeaders + '\n')
  const file = new Blob(data, { type: 'text/csv' });
  if (window.navigator.msSaveOrOpenBlob) // IE10+
    window.navigator.msSaveOrOpenBlob(file, filename);
  else { // Others
    var a = document.createElement("a"),
      url = URL.createObjectURL(file);
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    setTimeout(function () {
      document.body.removeChild(a);
      window.URL.revokeObjectURL(url);
    }, 0);
  }
}